<template>
	<div id="SideComponent" class="side-component">
		<button ref="btnGetStoreRackSide" @click="getStoreRackSideLocal(null)" v-show="false">Buscar Hijos</button>
		<button ref="btnGetStoreRackSideChildren" @click="getStoreRackSideChildrenLocal" v-show="false">Buscar Hijos</button>
		<button ref="btnGetStoreRackSideRowColumn" @click="getStoreRackSideRowColumnLocal" v-show="false">Buscar Hijos</button>
		<button ref="btnGetStoreRackSideRowColumnSelected" @click="getStoreRackSideRowColumnSelectedLocal" v-show="false">Enviar Ids Seleccionadas</button>
		<div v-if="!searchingStoreRackSide">
			<div class="text-center mb-2">
				<table style="margin: 0 auto;">
					<tr>
						<td>
							<h5 v-if="enableActiveNewStoreRackSideModule">
								<context-menu
									:text="objectStoreRackSide.store_rack.name + ' ' + objectStoreRackSide.name"
									title="Click derecho para mas opciones"
									:list="listMenusAdd"
									:multiSelect="false"
									:markSelection="false"
									localStorage="SideComponent"
									@actionSelectItem="actionSelectMenuItemAddLocal"
									ref="contextMenuAddRowColumn"
									:saveSelection="false">
								</context-menu>
							</h5>
							<h5 v-else>
								{{ objectStoreRackSide.store_rack.name + ' ' + objectStoreRackSide.name }}
							</h5>
						</td>
					</tr>
				</table>
			</div>
			<div class="table-responsive text-center">
				<table :style="'border: 2px solid '+ objectStoreRackSide.color" v-if="listStoreRackSideRows.length > 0" @contextmenu="showMenuAddRowColumn()">
					<tbody>
						<tr v-for="(item, index) in listStoreRackSideRows.slice().reverse()" :key="index">
							<td v-for="(ite, inde) in listStoreRackSideRowColumnsOrder" :key="inde"
								v-if="ite.store_rack_side_row_id == item.id"
								:colspan="ite.colspan"
								:style="'border: 1px solid '+ objectStoreRackSide.color"
								:class="(columnSelect(ite.id) ? 'bg-secondary' : '')"
								@click="selectStoreRackSideRowColumnLocal(ite)"
								@dblclick="showStoreRackSideRowColumnLocal(ite.id)"
								class="pointer">
								{{ite.name}} - {{item.name}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div v-else class="text-center">
			Buscando el lado del Rack
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import storeRackSide from '@/mixins/stores/storeRackSide.js'
	import storeRackSideRow from '@/mixins/stores/storeRackSideRow.js'
	import storeRackSideRowColumn from '@/mixins/stores/storeRackSideRowColumn.js'

	import ContextMenu from '@/components/ContextMenu.vue'

	export default {
		name: 'SideComponent',
		mixins: [axiosAction, errors, mixin, storeRackSide, storeRackSideRow, storeRackSideRowColumn],
		props: ['id', 'storeRackSideRowColumnIds', 'multipleSelection', 'enableActiveNewStoreRackSideModule'],
		data () {
			return {
				idLocal: 0,
				storeRackSideRowColumnIdsSelected: [],
				listMenusAdd: [
					{ id: 1, text: 'Agregar Fila', selected: false },
					{ id: 2, text: 'Agregar Columna', selected: false },
				],

			}
		},
		components: {
			'context-menu': ContextMenu,
		},
		computed: {
			listStoreRackSideRowColumnsOrder() {
				return (this.objectStoreRackSide.reverse == 1) ? this.listStoreRackSideRowColumns.slice().reverse() : this.listStoreRackSideRowColumns
			}
		},
		methods: {
			actionSelectMenuItemAddLocal(item) {
				this.addStoreRackSideRowColumn(this.idLocal, (item.id == 1) ? 'ROW' : 'COLUMN')
			},
			addStoreRackSideRowColumnResultLocal(response) {
				if(response.data.success == true) {
					if(response.data.data.storeRackSideRow != null && response.data.data.storeRackSideRow != undefined) {
						this.listStoreRackSideRows.push(response.data.data.storeRackSideRow)
					}
					response.data.data.storeRackSideRowColumns.forEach(element => {
						this.listStoreRackSideRowColumns.push(element)
					});
				}
			},
			columnSelect(columnId) {
				if(this.storeRackSideRowColumnIdsSelected == undefined) {
					return false
				}
				return (this.storeRackSideRowColumnIdsSelected.map(el => parseInt(el)).indexOf(parseInt(columnId)) > -1)
			},
			getStoreRackSideLocal(id = null) {
				this.idLocal = (id == null) ? this.id : id
				this.listStoreRackSideRows = []
				this.listStoreRackSideRowColumns = []
				this.storeRackSideRowColumnIdsSelected = (this.storeRackSideRowColumnIds == undefined) ? [] : this.storeRackSideRowColumnIds
				this.getStoreRackSide(this.idLocal)
			},
			getStoreRackSideResultLocal(response) {
				if(response.data.success == true) {
					this.getStoreRackSideChildrenLocal()
				}
			},
			getStoreRackSideChildrenLocal() {
				this.listStoreRackSideRows = []
				this.listStoreRackSideRowColumns = []
				this.getStoreRackSideChildren(this.idLocal)
			},
			getStoreRackSideChildrenResultLocal(response) {
				if(response.data.success == true) {
					this.listStoreRackSideRows = response.data.data.store_rack_side_rows
					this.listStoreRackSideRowColumns = response.data.data.store_rack_side_row_columns
				}
				setTimeout(()=>{ 
					if(this.enableActiveNewStoreRackSideModule) {
						this.$refs.contextMenuAddRowColumn.$refs.btnEjecute.click()
					}
				}, 20)
			},
			getStoreRackSideRowColumnLocal() {
				this.storeRackSideRowColumnIdsSelected = this.storeRackSideRowColumnIds

				this.getStoreRackSideRowColumn(this.storeRackSideRowColumnIdsSelected[0])
			},
			getStoreRackSideRowColumnResultLocal(response) {
				if(response.data.success) {
					this.getStoreRackSideLocal(response.data.data.store_rack_side_id)
				}
			},
			getStoreRackSideRowColumnSelectedLocal() {
				this.$emit('actionGetStoreRackSideRowColumnIdsSelected', this.storeRackSideRowColumnIdsSelected)
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'addStoreRackSideRowColumnResult': this.addStoreRackSideRowColumnResult(response); break;				
					case 'getStoreRackSideResult': this.getStoreRackSideResult(response); break;				
					case 'getStoreRackSideChildrenResult': this.getStoreRackSideChildrenResult(response); break;				
					case 'getStoreRackSideRowColumnResult': this.getStoreRackSideRowColumnResult(response); break;			
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			selectStoreRackSideRowColumnLocal(item) {
				if(this.multipleSelection == true) {
					let index = this.storeRackSideRowColumnIdsSelected.map(e => parseInt(e)).indexOf(item.id)
					if(index == -1) {
						this.storeRackSideRowColumnIdsSelected.push(item.id)
					} else {
						this.storeRackSideRowColumnIdsSelected.splice(index, 1)
					}
				} else {
					this.$emit('actionClickModule', item)
				}
			},
			showMenuAddRowColumn() {
				alert('hola')
			},
			showStoreRackSideRowColumnLocal(id) {
				this.$emit('actionShowStoreRackSideRowColumn', id)
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.side-component {
	.table-responsive{
		table {
			margin: 0 auto;
			td {
				width: 150px;
				height: 50px;
			}
		}
	}
}
</style>
